"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenService = void 0;
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
const index_1 = require("./index");
class TokenService {
    constructor() {
        this.__priority = 100;
        this.tokens = mobx_1.observable.map();
    }
    init() {
        (0, mobx_1.reaction)(() => index_1.Services.Department.current, () => {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.updateTokens();
        }, { name: 'TokenService:department' });
    }
    updateTokens() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const currentDepartment = index_1.Services.Department.current;
            if (currentDepartment == null) {
                this.tokens.clear();
            }
            else {
                const tokens = yield index_1.Services.Department.rest.tokens.fetch();
                this.setTokens(tokens);
            }
            index_1.Services.Route.tokensLoaded = true;
        });
    }
    setTokens(tokens) {
        this.tokens.clear();
        for (const t of tokens) {
            this.tokens.set(t.name, t.name);
        }
    }
    has(token) {
        return this.tokens.has(token);
    }
    hasAll(tokens) {
        tokens = Array.isArray(tokens) ? tokens : [];
        for (const token of tokens) {
            if (!this.tokens.has(token)) {
                return false;
            }
        }
        return true;
    }
    getByPrefix(prefix) {
        const tokens = Array.from(this.tokens.keys());
        return tokens.filter((token) => token.startsWith(prefix));
    }
}
exports.TokenService = TokenService;
tslib_1.__decorate([
    mobx_1.action
], TokenService.prototype, "updateTokens", null);
tslib_1.__decorate([
    mobx_1.action
], TokenService.prototype, "setTokens", null);
//# sourceMappingURL=token.service.js.map